import '../../sass/blocks/add-a-sample.scss';

import cachios from 'cachios';
import Details from '../classes/Details';

const noMotionPreference = window.matchMedia('(prefers-reduced-motion: no-preference)');

(() => {
    const $siteHeader = document.querySelector('.site-header');
    const $addASamples = document.querySelectorAll('.add-a-sample');

    if (!$addASamples) return;

    $addASamples.forEach($addASample => {
        const $dropdowns = $addASample.querySelectorAll('.add-a-sample-dropdown');

        const $productAddASampleBtns = $addASample.querySelectorAll('.add-a-sample-btn--product');

        const $productsDropdown = $addASample.querySelector('.add-a-sample-dropdown--products');
        const $finishesDropdown = $addASample.querySelector('.add-a-sample-dropdown--finishes');
        const $coloursDropdown = $addASample.querySelector('.add-a-sample-dropdown--colours');

        const $finishesContent = $addASample.querySelector('.add-a-sample-dropdown__content--finishes');
        const $coloursContent = $addASample.querySelector('.add-a-sample-dropdown__content--colours');

        const $addASampleOrderForm = $addASample.querySelector('.add-a-sample-order-form');
        const $addASampleOrderFormProductId = $addASampleOrderForm.querySelector('[name=product_id]');
        const $addASampleOrderFormFinishId = $addASampleOrderForm.querySelector('[name=finish_id]');
        const $addASampleOrderFormColourId = $addASampleOrderForm.querySelector('[name=colour_id]');

        let productsDropdown, finishesDropdown, coloursDropdown;

        const initDetails = () => {
            if ($productsDropdown) {
                productsDropdown = new Details($productsDropdown);
            }

            if ($finishesDropdown) {
                finishesDropdown = new Details($finishesDropdown);
            }

            if ($coloursDropdown) {
                coloursDropdown = new Details($coloursDropdown);
            }
        };

        const initCarousel = () => {
            const $carousel = $addASample.querySelector('.add-a-sample-colours-carousel');
            const $carouselColourNavBtns = $addASample.querySelectorAll('.add-a-sample-colours-nav-btn');

            if (!$carousel) return;

            const carousel = new Swiper($carousel, {
                slidesPerView: 'auto',
                keyboard: {
                    enabled: true,
                    onlyInViewport: true
                },
                speed: noMotionPreference.matches ? 300 : 0,
            });

            if ($carouselColourNavBtns) {
                $carouselColourNavBtns.forEach($carouselNavBtn => {
                    $carouselNavBtn.addEventListener('click', () => {
                        const { index } = $carouselNavBtn.dataset;

                        carousel.slideTo(index);
                    });
                });

                carousel.on('slideChange', () => {
                    const $prevActiveCarouselNavBtn = $addASample.querySelector('.add-a-sample-colours-nav-btn--active');

                    if ($prevActiveCarouselNavBtn) {
                        $prevActiveCarouselNavBtn.classList.remove('add-a-sample-colours-nav-btn--active');
                    }

                    const $activeCarouselNavBtn = $carouselColourNavBtns[carousel.activeIndex];

                    if ($activeCarouselNavBtn) {
                        $activeCarouselNavBtn.classList.add('add-a-sample-colours-nav-btn--active');
                    }
                });
            }

            const $slides = $carousel.querySelectorAll('.swiper-slide');

            if (carousel && $slides) {
                $slides.forEach(($slide, index) => {
                    const $activeColourSwatch = $slide.querySelector('.add-a-sample-colour-btn--active');

                    if ($activeColourSwatch) {
                        carousel.slideTo(index, 0);
                    }
                })
            }
        };

        const initProductBtns = () => {
            if (!$productAddASampleBtns) return;
            
            $productAddASampleBtns.forEach($btn => {
                const { productId, nonce } = $btn.dataset;

                $btn.addEventListener('click', e => {
                    e.preventDefault();

                    cachios.get(GLOBALS.AJAX_URL, {
                        params: {
                            action: 'armourcoat_theme_ajax_get_add_a_sample_product_finishes_and_colours', 
                            nonce,
                            product_id: productId,
                            page_link: window.location.href
                        }
                    }).then(response => {
                        if (response?.data?.success) {
                            const $activeProductAddASampleBtns = $addASample.querySelectorAll('.add-a-sample-btn--product.add-a-sample-btn--active');

                            if ($activeProductAddASampleBtns) {
                                $activeProductAddASampleBtns.forEach($activeProductAddASampleBtn => {
                                    $activeProductAddASampleBtn.classList.remove('add-a-sample-btn--active');
                                });
                            }

                            if (response?.data?.finishes) {
                                $finishesContent.innerHTML = response.data.finishes;

                                productsDropdown?.close();
                                finishesDropdown?.open();
                                coloursDropdown?.close();

                                $productsDropdown.removeAttribute('disabled');
                                $finishesDropdown.removeAttribute('disabled');
                                $coloursDropdown.setAttribute('disabled', true);
                            }

                            if (!response?.data?.finishes && response?.data?.colours) {
                                $coloursContent.innerHTML = response.data.colours;

                                productsDropdown?.close();
                                finishesDropdown?.close();
                                coloursDropdown?.open();

                                $productsDropdown.removeAttribute('disabled');
                                $finishesDropdown.setAttribute('disabled', true);
                                $coloursDropdown.removeAttribute('disabled');
    
                                initCarousel();
                                initColourBtns();
                            }

                            if (response?.data?.colours || response?.data?.finishes) {
                                $btn.classList.add('add-a-sample-btn--active');

                                initCarousel();
                                initFinishBtns();

                                window.history.pushState(null, document.title, $btn.href);

                                $addASampleOrderForm.classList.add('add-a-sample-order-form--disabled');
                            }
                        }
                    }).catch(thrown => {
                        console.log(thrown);
                    });
                });
            });
        };

        const initFinishBtns = () => {
            const $finishAddASampleBtns = $addASample.querySelectorAll('.add-a-sample-btn--finish');

            if (!$finishAddASampleBtns) return;

            $finishAddASampleBtns.forEach($btn => {
                const { productId, finishId, nonce } = $btn.dataset;

                $btn.addEventListener('click', e => {
                    e.preventDefault();

                    cachios.get(GLOBALS.AJAX_URL, {
                        params: {
                            action: 'armourcoat_theme_ajax_get_add_a_sample_finish_colours', 
                            nonce,
                            product_id:productId,
                            finish_id: finishId,
                            page_link: window.location.href
                        }
                    }).then(response => {
                        if (response?.data?.success) {
                            const $activeFinishAddASampleBtns = $addASample.querySelectorAll('.add-a-sample-btn--finish.add-a-sample-btn--active');

                            if ($activeFinishAddASampleBtns) {
                                $activeFinishAddASampleBtns.forEach($activeFinishAddASampleBtn => {
                                    $activeFinishAddASampleBtn.classList.remove('add-a-sample-btn--active');
                                });
                            }
    
                            $btn.classList.add('add-a-sample-btn--active');

                            if (response?.data?.colours) {
                                $coloursContent.innerHTML = response.data.colours;

                                productsDropdown?.close();
                                finishesDropdown?.close();
                                coloursDropdown?.open();

                                $productsDropdown.removeAttribute('disabled');
                                $finishesDropdown.removeAttribute('disabled');
                                $coloursDropdown.removeAttribute('disabled');
    
                                initCarousel();
                                initColourBtns();
    
                                window.history.pushState(null, document.title, $btn.href);
    
                                $addASampleOrderForm.classList.add('add-a-sample-order-form--disabled');
                            }

                            if (!response?.data?.colours) {
                                setAddSampleFormFields(productId, finishId);
                            }
                        }
                    }).catch(thrown => {
                        console.log(thrown);
                    });
                });
            });
        };

        const initColourBtns = () => {
            const $colourAddASampleBtns = $addASample.querySelectorAll('.add-a-sample-colours-btn--colour');

            if (!$colourAddASampleBtns) return;

            $colourAddASampleBtns.forEach($btn => {
                const { productId, finishId, colourId } = $btn.dataset;
                
                $btn.addEventListener('click', e => {
                    e.preventDefault();

                    const $activeColourAddASampleBtns = $addASample.querySelectorAll('.add-a-sample-colours-btn--colour.add-a-sample-colours-btn--active');
        
                    if ($activeColourAddASampleBtns) {
                        $activeColourAddASampleBtns.forEach($activeColourAddASampleBtn => {
                            $activeColourAddASampleBtn.classList.remove('add-a-sample-colours-btn--active');
                        });
                    }

                    $btn.classList.add('add-a-sample-colours-btn--active');

                    window.history.pushState(null, document.title, $btn.href);

                    setAddSampleFormFields(productId, finishId, colourId);
                });
            });
        };

        const setAddSampleFormFields = (productId = null, finishId = null, colourId = null) => {
            $addASampleOrderFormProductId.value = productId ?? '';
            $addASampleOrderFormFinishId.value = finishId ?? '';
            $addASampleOrderFormColourId.value = colourId ?? '';

            $addASampleOrderForm.classList.remove('add-a-sample-order-form--disabled');
            
            const scrollToPos = $addASampleOrderForm.getBoundingClientRect().top + $addASampleOrderForm.offsetHeight + window.scrollY - window.innerHeight;

            if (scrollToPos > window.scrollY) {
                window.scrollTo({
                    top: scrollToPos,
                    behavior: 'smooth'
                });
            }
        };

        initDetails();
        initCarousel();
        initProductBtns();
        initFinishBtns();
        initColourBtns();
    })
})();
